module.exports = __webpack_public_path__ + "static/media/img-epaper-bg-UNSUB-S.a1124374.jpg";